
classPoints = function() {

    var self = this;
    this.textOrientation = '';
    this.text = ''
    this.textX = 0;
    this.textY = 0;
    this.imageX = 0;
    this.imageY = 0;
    this.image = new Image();
    this.imageSize = 0;
    this.drumPoint = true;
    this.pointNumber = 0;

    this.setPointNumber = function(number) {
        self.pointNumber = number;
        return self;
    }

    this.setText = function(text) {
        self.text = text;
        return self;
    }

    this.setDrumPoint = function(value) {
        self.drumPoint = value;
        return self;
    }

    this.setTextOrientation = function(orientation) {
        self.textOrientation = orientation;
        return self;
    }

    this.setImageSize = function(size) {
        self.imageSize = size;
        return self;
    }

    this.setImage = function(image) {
        self.image = image;
        return self;
    }

    this.setImageX = function(x) {
        self.imageX = x;

        if (self.textOrientation == 'right') {
            self.textX = x + self.imageSize - 1;
        } else {

            self.text = '' + self.text;

            if (self.text.length > 1) {
                self.textX = x - self.imageSize + 36;
            } else {
                self.textX = x - self.imageSize + 45;
            }

        }

        return self;
    }

    this.setImageY = function(y) {
        self.imageY = y;

        self.textY = y + (self.imageSize / 2) + 7;
        return self;
    }

    this.drawer = new function() {
        this.draw = function() {
            if (self.drumPoint) {
                var pointImage = new classImage(self.image)
                        .setX(self.imageX)
                        .setY(self.imageY)
                        .setWidth(self.imageSize)
                        .setHeight(self.imageSize);
                pointImage.drawer.draw();

                if (self.pointNumber == state.bonusballs[0] || self.pointNumber == state.bonusballs[1]) {
                    var flowerImage = new classImage(images.flower)
                            .setX(self.imageX + 8)
                            .setY(self.imageY + 8)
                            .setWidth(38)
                            .setHeight(38);
                    flowerImage.drawer.draw();
                }

                var pointText = new classText()
                        .setX(self.textX)
                        .setY(self.textY)
                        .setFontSize('17px')
                        .setFontFamily('FuturaHeavy')
                        .setText(self.text);
                pointText.drawer.draw();
            }

        }

    }

    this.pickNumber = function() {
        if (self.drumPoint) {

            var bonusImage = new classImage(images[mode + '_number_picked'])
                    .setX(self.imageX + 2)
                    .setY(self.imageY + 2)
                    .setWidth(self.imageSize * 2)
                    .setHeight(self.imageSize - 4);

            if (self.textOrientation == "left") {
                bonusImage.rotate(180);
                bonusImage.setX(self.imageX - self.imageSize - 2);
            }

            var elementId = 'bonusImage' + scene.counter;
            scene.add(bonusImage, elementId);

        } else {
            console.log('CRITICAL: Drum point cannot be marked as bonus point!');
        }
    }

    this.removePickNumber = function(elementId) {
        scene.remove(elementId);
    }

    this.isInteger = function(n) {
        return n === parseInt(n);
    }

    this.isOdd = function(n) {
        return self.isInteger(n) && (n % 2 !== 0);
    }

    this.appendBall = function(number) {
        window['drawnNumbers'].push(number);

        // show odd/even
        if (self.isOdd(number)) {
            if (drawnOddBalls < 18)
                oddNumbersHolders[drawnOddBalls].appendOdd();
            drawnOddBalls++;
        } else {
            if (drawnEvenBalls < 18)
                evenNumbersHolders[drawnEvenBalls].appendEven();
            drawnEvenBalls++;
        }

        // update numeric counters
        scene.elements.odd_counter.setText(drawnOddBalls);
        // move left if one digit number!!!
        if(drawnOddBalls < 10) { 
            scene.elements.odd_counter.x = 340;
        }
        else {
            scene.elements.odd_counter.x = 334;
        }
        scene.elements.even_counter.setText(drawnEvenBalls);

        // show small balls (animated)
        var smallBall = new classSmallBalls(number, self.imageX, self.imageY, self.imageSize);
        scene.add(smallBall, 'ball_' + window['drawnBalls']);

        window['drawnBalls'] ++;

        // first ball
        if (window['drawnBalls'] == 1) {
            // set first ball color
            firstBallColor = smallBall.color;
        }

        // show preballs sum if it's 5th drawn ball
        if (window['drawnBalls'] == 5) {
            preballsSum = scene.elements.ball_0.ballNumber + scene.elements.ball_1.ballNumber + scene.elements.ball_2.ballNumber + scene.elements.ball_3.ballNumber + scene.elements.ball_4.ballNumber;
            scene.add(new classText()
                    .setX(110)
                    .setY(435)
                    .setFontSize('11px')
                    .setFontFamily('FuturaHeavy')
                    .setText(preballsSum),
                    'preballs_sum')
        }

        // update color counters
        switch (smallBall.color) {
            case "red":
                drawnColors.red = drawnColors.red + 1;
                if(drawnColors.red == 6) colorBettingHolders[shownColorBetting].append('red');
                break;
            case "blue":
                drawnColors.blue = drawnColors.blue + 1;
                if(drawnColors.blue == 6) colorBettingHolders[shownColorBetting].append('blue');
                break;
            case "green":
                drawnColors.green = drawnColors.green + 1;
                if(drawnColors.green == 6) colorBettingHolders[shownColorBetting].append('green');
                break;
            case "purple":
                drawnColors.purple = drawnColors.purple + 1;
                if(drawnColors.purple == 6) colorBettingHolders[shownColorBetting].append('purple');
                break;
            case "brown":
                drawnColors.brown = drawnColors.brown + 1;
                if(drawnColors.brown == 6) colorBettingHolders[shownColorBetting].append('brown');
                break;
            case "yellow":
                drawnColors.yellow = drawnColors.yellow + 1;
                if(drawnColors.yellow == 6) colorBettingHolders[shownColorBetting].append('yellow');
                break;
            case "green":
                drawnColors.green = drawnColors.green + 1;
                if(drawnColors.green == 6) colorBettingHolders[shownColorBetting].append('green');
                break;
            case "orange":
                drawnColors.orange = drawnColors.orange + 1;
                if(drawnColors.orange == 6) colorBettingHolders[shownColorBetting].append('orange');
                break;
            case "black":
                drawnColors.black = drawnColors.black + 1;
                if(drawnColors.black == 6) colorBettingHolders[shownColorBetting].append('black');
                break;
        }

        // Last ball
        if (window['drawnBalls'] == 35) {
            // Set last ball color
            lastBallColor = smallBall.color;
            mostCommonColors = getMostCommonColors();
        }

        if(window['drawnBalls'] == state.bonusballs[0] || window['drawnBalls'] == state.bonusballs[1]) {
            scene.elements['point_' + (window['drawnBalls'] - 1)]. pickNumber();
            bonusNumbers.push(number);
        }
    }
}


classPointsResults = function() {
    var self = this;

    this.textOrientation = '';
    this.text = ''
    this.textX = 0;
    this.textY = 0;
    this.imageX = 0;
    this.imageY = 0;
    this.image = new Image();
    this.imageSize = 0;
    this.drumPoint = true;

    this.setText = function(text) {
        self.text = text;
        return self;
    }

    this.setDrumPoint = function(value) {
        self.drumPoint = value;
        return self;
    }

    this.setTextOrientation = function(orientation) {
        self.textOrientation = orientation;
        return self;
    }

    this.setImageSize = function(size) {
        self.imageSize = size;
        return self;
    }

    this.setImage = function(image) {
        self.image = image;
        return self;
    }

    this.setImageX = function(x) {
        self.imageX = x;

        if (self.textOrientation == 'right') {
            self.textX = x + self.imageSize - 1;
        } else {
            self.text = '' + self.text;

            if (self.text.length > 1) {
                self.textX = x - self.imageSize + 36;
            } else {
                self.textX = x - self.imageSize + 45;
            }

        }
        return self;
    }

    this.setImageY = function(y) {
        self.imageY = y;
        self.textY = y + (self.imageSize / 2) + 7;
        return self;
    }

    this.drawer = new function() {
        // Override
        this.draw = function() {
            if (self.drumPoint) {

                var pointImage = new classImage(self.image)
                        .setX(self.imageX)
                        .setY(self.imageY)
                        .setWidth(self.imageSize)
                        .setHeight(self.imageSize);
                pointImage.drawer.draw();

                var pointText = new classText()
                        .setX(self.textX)
                        .setY(self.textY)
                        .setFontSize('17px')
                        .setFontFamily('FuturaHeavy')
                        .setText(self.text);
                pointText.drawer.draw();
            }

        }

    }

    this.isInteger = function(n) {
        return n === parseInt(n);
    }

    this.isOdd = function(n) {
        return self.isInteger(n) && (n % 2 !== 0);
    }

    this.appendBall = function(number) {
        window['drawnNumbers'].push(number);
        // Show odd/even
        if (self.isOdd(number)) {
            if (drawnOddBalls < 18)
                oddNumbersHolders[drawnOddBalls].appendOdd();
            drawnOddBalls++;
        } else {
            if (drawnEvenBalls < 18)
                evenNumbersHolders[drawnEvenBalls].appendEven();
            drawnEvenBalls++;
        }

        // Update numeric counters
        scene.elements.odd_counter.setText(drawnOddBalls);
        scene.elements.even_counter.setText(drawnEvenBalls);

        // Show preballs sum if it's 5th drawn ball
        if (shownBalls == 5) {
            preballsSum = scene.elements.ball_0.ballNumber + scene.elements.ball_1.ballNumber + scene.elements.ball_2.ballNumber + scene.elements.ball_3.ballNumber + scene.elements.ball_4.ballNumber;
            scene.add(new classText()
                    .setX(110)
                    .setY(435)
                    .setFontSize('11px')
                    .setFontFamily('FuturaHeavy')
                    .setText(preballsSum),
                    'preballs_sum')
        }

        // Show small balls (animated)
        var smallBall = new classSmallBalls(number, self.imageX, self.imageY, self.imageSize);
        scene.add(smallBall, 'ball_' + shownBalls);

        shownBalls++;

    }
}


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/points.js
// module id = 848
// module chunks = 2